import ScheduleApi from '../../api-services/ScheduleApi';

import ScheduleMain from '../../schedules/ScheduleMain';

export default class AggregableMain extends ScheduleMain {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    this.summaryDataModel.dispose();

    super.componentWillUnmount();
  }

  async loadGridValues() {
    this.closePopOutEditor();

    var scheduleUpdateDto = await ScheduleApi.getFullUpdate(
      this.counterparty.code,
      this.commandDataModel.currentMonth
    );

    this.dataModel.processFullServerUpdate(scheduleUpdateDto);

    this.commandDataModel.updateProperties({
      isEditingEnabled: this.dataModel.isEditingEnabled,
      canUserManageColumnPreferences: scheduleUpdateDto.canUserManageColumnPreferences,
      currentContracts: this.dataModel.contracts,
      resubmitContracts: this.dataModel.contracts.filter(contract => contract.enableResubmitValues),
      recalculateContracts: this.dataModel.contracts.filter(contract => contract.enableRecalculateValues)
    });
  }

  async updateGridValues(lastRetrievalTimeUtc) {
    var scheduleUpdateDto = await ScheduleApi.getPartialUpdate(
      this.counterparty.code,
      this.commandDataModel.currentMonth,
      lastRetrievalTimeUtc
    );

    this.dataModel.processBackgroundServerUpdate(scheduleUpdateDto);
  }

  submitGridChanges(onSubmitFinished) {
    this.closePopOutEditor();

    var dateSubmissions = this.dataModel.getCurrentModifications();
    ScheduleApi.submitChanges(
      this.counterparty.code,
      dateSubmissions,
      onSubmitFinished,
      false
    );
  }

  revertGridChanges() {
    this.closePopOutEditor();
    this.dataModel.revertCurrentModifications();
  }

  onViewKeyDown(event) {
    super.onViewKeyDown(event);

    if (event.key === 'Escape') {
      this.closePopOutEditor();
    }
  }

  onDataGridEditingStart(event) {
    super.onDataGridEditingStart(event);
  }

  onDataGridKeyDown(event) {
    if (event.event.code === 'Escape') {
      this.closePopOutEditor();
    }
  }

  onDataGridContextMenuPreparing(event) {
    if (event.target !== 'content')
      return;

    var disabled = true;

    if (disabled) {
      event.items = [];
      return;
    }

    event.items = [];
  }
}
